<template>
  <div class="itemTop" :class="{ isActive }">
    <MiniButton
      class="select-button"
      v-if="isActive"
      @clickButton="resetFixedItem()"
    >
      <svg
        class="pin-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 13 13"
        width="13px"
        height="13px"
      >
        <g>
          <path
            d="M9.55,11.41c1.36-1.36.91-3.31.54-4.27L10.86,6a2,2,0,0,0,1.54-.57c1.18-1.18.44-3.11-.65-4.19S8.74-.58,7.56.6A2,2,0,0,0,7,2.14l-1.13.77c-1-.36-2.91-.82-4.27.55C-.06,5.1.68,8,2.4,9.92L.14,12.18a.48.48,0,0,0,0,.68.48.48,0,0,0,.68,0l2.26-2.25C5,12.32,7.9,13.06,9.55,11.41Zm1.57-9.53c.83.84,1.27,2.2.6,2.87s-1.92.33-2.86-.61S7.61,1.91,8.24,1.28s2-.23,2.88.6Zm-2.9,2.9a4.41,4.41,0,0,0,1.64,1L8,8.44c-.6.55-1.82.37-2.83-.64S4,5.57,4.56,5L7.18,3.15a4.55,4.55,0,0,0,1,1.64ZM3.39,9.61C1.65,7.87,1,5.37,2.27,4.13a2.79,2.79,0,0,1,2.65-.58L4,4.2c-.65.58-1.17,2.44.62,4.22S8.22,9.69,8.8,9l.65-1a2.79,2.79,0,0,1-.58,2.65C7.63,12,5.12,11.36,3.38,9.62Z"
          />
        </g>
      </svg>
      <span class="minibutton-text">固定解除</span>
    </MiniButton>
    <MiniButton class="select-button" v-else @clickButton="fixItem()">
      <svg
        class="pin-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 13 13"
        width="13px"
        height="13px"
      >
        <g>
          <path
            d="M9.55,11.41c1.36-1.36.91-3.31.54-4.27L10.86,6a2,2,0,0,0,1.54-.57c1.18-1.18.44-3.11-.65-4.19S8.74-.58,7.56.6A2,2,0,0,0,7,2.14l-1.13.77c-1-.36-2.91-.82-4.27.55C-.06,5.1.68,8,2.4,9.92L.14,12.18a.48.48,0,0,0,0,.68.48.48,0,0,0,.68,0l2.26-2.25C5,12.32,7.9,13.06,9.55,11.41Zm1.57-9.53c.83.84,1.27,2.2.6,2.87s-1.92.33-2.86-.61S7.61,1.91,8.24,1.28s2-.23,2.88.6Zm-2.9,2.9a4.41,4.41,0,0,0,1.64,1L8,8.44c-.6.55-1.82.37-2.83-.64S4,5.57,4.56,5L7.18,3.15a4.55,4.55,0,0,0,1,1.64ZM3.39,9.61C1.65,7.87,1,5.37,2.27,4.13a2.79,2.79,0,0,1,2.65-.58L4,4.2c-.65.58-1.17,2.44.62,4.22S8.22,9.69,8.8,9l.65-1a2.79,2.79,0,0,1-.58,2.65C7.63,12,5.12,11.36,3.38,9.62Z"
          />
        </g>
      </svg>
      <span class="minibutton-text">固定する</span>
    </MiniButton>
    <div class="card-top">
      <div class="card-nameWrapper">
        <p class="card-brand">{{ brandName }}</p>
        <p class="card-name">{{ data.product_name }}</p>
      </div>
      <div class="card-image">
        <img
          :src="`https://imagecdn.shiseido.co.jp/c/a=0,f=webp:jpeg/resources/sw${data.shohin_pl_c_gzfl_pth}`"
          alt=""
          width="184"
          height="184"
          loading="lazy"
        />
      </div>
      <div class="detail-buttonWrapper">
        <a
          class="detail-button"
          :href="`https://www.shiseido.co.jp/sw/c/products/SWFG070410.seam?&shohin_pl_c_cd=${data.pool_code}&online_shohin_ctlg_kbn=1`"
          target="_blank"
          @click="handleClickDetail"
          >商品詳細を見る</a
        >
      </div>
      <div class="ranking"><RankingIcon :number="data.ranking_num" /></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import RankingIcon from "../../ui/RankingIcon.vue";
import MiniButton from "../../ui/buttons/MiniButton.vue";
import { adobeClickEvent } from "../../../modules/analytics";

export default {
  name: "ItemTop",
  components: { RankingIcon, MiniButton },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        brand_name_text: "",
        brand_code: "",
        brnd_lg_gz_fl_pth: "",
        product_name: "",
        jan_code: "",
        pool_code: "",
        ranking_num: -1,
        komi_kkk: 0,
        hyoji_yo_naiyo_ryo: "",
        shohin_pl_c_gzfl_pth: "",
      }),
    },
  },
  computed: {
    ...mapGetters("jsonData", ["tables", "forms"]),
    brandName() {
      return this.tables.brand_names[this.data.brand_name];
    },
  },
  methods: {
    analyze(eventId, url) {
      adobeClickEvent(eventId, url);
    },
    resetFixedItem() {
      this.analyze(`kotei_kaijo_${this.data.pool_code}`);
      this.$store.dispatch("product/setFixedId", { id: "" });
    },
    fixItem() {
      this.analyze(`kotei_${this.data.pool_code}`);
      this.$store.dispatch("product/setFixedId", { id: this.data.jan_code });
    },
    handleClickDetail(e) {
      const url = e.currentTarget.href;
      this.analyze(`shohinshosai_${this.data.pool_code}`, url);
    },
  },
};
</script>
<style lang="scss" scoped>
.itemTop {
  $shadowColor: rgba(0, 0, 0, 0.05);
  $itemWidth: 220px;

  width: $itemWidth;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;

  .select-button {
    width: 90px;
  }
  .pin-icon {
    width: 13px;
    height: 13px;
    margin-right: 5px;
  }

  .card-top {
    width: 100%;
    border-radius: 10px 10px 0 0;
    margin-top: 10px;
    border: 2px solid transparent;
    border-bottom: none;
    position: relative;
    background-color: #fff;
    padding: 2px 20 - 2 * 2px 8px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    box-shadow: 0 -2px 10px 2px $shadowColor;
    /* top: 3px; */

    // card上部の中身
    .card-nameWrapper {
      order: 2;
      width: 100%;
      margin-top: 6px;
      text-align: left;
    }
    .card-brand {
      line-height: 1.5;
      font-size: 12px;
    }
    .card-name {
      font-size: 12px;
      // font-weight: 600;
      line-height: 1.5;
      margin-top: 4px;
    }
    .card-image {
      order: 1;
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      & > img {
        object-fit: contain;
      }
    }

    .detail-buttonWrapper {
      order: 3;
      margin-top: auto;
      width: 100%;
    }

    .detail-button {
      margin-top: 6px;
      font-family: "Noto Sans JP";
      font-weight: 500;
      color: #fff;
      background-color: $main-red;
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 13px 0;
      border-radius: 100px;
      cursor: pointer;
      letter-spacing: 2px;
      text-decoration: none;
      opacity: 1;
      transition: letter-spacing 0.3s $easing-color;
      @media (hover: hover) {
        &:hover {
          letter-spacing: 4px;
        }
      }
    }
    .ranking {
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }

  &.isActive {
    &::before,
    &::after {
      content: "";
      display: block;
      width: 2px;
      height: 1px;
      background-color: $main-red;
      position: absolute;
      z-index: 1;
      bottom: -1px;
    }

    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
    .card-top {
      border: 2px solid $main-red;
      border-bottom: none;
    }
  }

  @include media() {
    $itemWidth: vw(120);

    width: $itemWidth;
    background-color: #fff;

    .select-button {
      width: 100%;
    }
    .pin-icon {
      width: vw(10);
      height: vw(10);
      margin-right: vw(4);
    }

    .card-top {
      width: 100%;
      border-radius: vw(10) vw(10) 0 0;
      margin-top: vw(15);
      padding: vw(4) vw(8) vw(4);
      box-shadow: 0 vw(-0.25) vw(4) vw(2) $shadowColor;
      /* top: vw(3); */

      // card上部の中身
      .card-nameWrapper {
        order: 2;
        margin-top: vw(4);
      }
      .card-brand {
        line-height: 1.4;
        font-size: vw(10);
      }
      .card-name {
        margin-top: vw(2);
        line-height: 1.4;
        font-size: vw(10);
      }

      .detail-button {
        margin-top: vw(2);
        padding: vw(7) 0;
        letter-spacing: 0.3vw;
        font-size: vw(10);
        @media (hover: hover) {
          &:hover {
            letter-spacing: vw(4);
          }
        }
      }
      .ranking {
        top: vw(7);
        right: vw(4);
      }
    }

    &.isActive {
      .card-top {
        border: 2px solid $main-red;
        border-bottom: none;
      }
    }
  }
}
</style>
